import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

/**
 * Shown inside an assistant bubble when tier=T3 and the message is a
 * research ack (has a job_id). Displays a spinner + "Researching…"
 */
export function ResearchPending() {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <View style={styles.row}>
      <ActivityIndicator size="small" color={theme.colors.primary} />
      <Text style={[styles.label, { color: theme.colors.textSecondary }]}>
        {t('chat.researching', { defaultValue: 'Researching…' })}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginTop: 6,
  },
  label: {
    fontSize: 13,
    fontStyle: 'italic',
  },
});
